import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { Axios } from "./middleware/axiosInstance";
const env = process.env.REACT_APP_ENV_HOST;
const API_HOST = require("../config.json")["API_HOST"][env];

function sendMail(window, email, content, close, updateData) {
  Axios({
    method: "POST",
    withCredentials: true,
    url: `${API_HOST}/notification/send`,
    data: {
      window: window,
      email: email,
      content: content,
    },
  })
    .then((res) => {
      console.log(res.data);
      updateData();
      close();
    })
    .catch((res) => {
      console.log(res.data);
      updateData();
      close();
    });
}
function sendNotification(hook, id) {
  Axios({
    method: "POST",
    withCredentials: true,
    url: `${API_HOST}/notification/send`,
    data: { _id: id },
  }).then((res) => {
    if (!res.data.err) {
      //getNotifications(hook);
    } else {
      console.log(res.data.msg);
    }
  });
}

const types = [{ name: "Rozładunek" }, { name: "Załadunek" }];

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles((theme) => ({
  marginBottom: {
    marginBottom: 20,
  },
  marginRight: {
    marginRight: 20,
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs({
  window,
  open,
  onClose = (f) => f,
  updateData = (f) => f,
}) {
  const [content, setContent] = React.useState("Treść powiadomienia");
  const [email, setEmail] = React.useState("1");
  const [name, setName] = React.useState("1");
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  const handleContentChange = (event) => {
    setContent(event.target.value);
  };
  React.useEffect(() => {
    if (window.client) {
      setName(window.client.name);
      setEmail(window.client.email);
    }
  }, [window]);
  const classes = useStyles();
  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={onClose}>
          Wiadomość e-mail
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            label="Kontrahent"
            fullWidth={true}
            className={classes.marginBottom}
            defaultValue={name}
            disabled
          />
          <TextField
            label="E-mail"
            fullWidth={true}
            className={classes.marginBottom}
            onChange={handleEmailChange}
            defaultValue={email}
          />
          <TextField
            label="Treść"
            fullWidth={true}
            className={classes.marginBottom}
            onChange={handleContentChange}
            defaultValue={content}
            multiline
          />
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              sendMail(window, email, content, onClose, updateData);
            }}
            color="primary"
          >
            Wyślij
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
